import React from "react"
import { array } from "prop-types"
import { connect } from "react-redux"
import DenyReasonModal from "../userSearchResults/modals/denyreason-container"

const MODAL_COMPONENTS = {
  DENY_REASON: DenyReasonModal
}

const ModalRoot = ({ modals = [] }) => {
  if (modals.length === 0) {
    return null
  }
  return modals.map(modal => {
    const SpecificModal = MODAL_COMPONENTS[modal.modalType]

    if (modal.modalType) {
      return <SpecificModal show={!modal.isClosing} key={modal.modalType} {...modal.modalProps} />
    }
  })
}

ModalRoot.propTypes = {
  modals: array,
}

ModalRoot.defaultProps = {
  modals: [],
}

const mapStateToProps = state => {
  const modals = state.modals

  return {
    modals,
  }
}

export default connect(mapStateToProps)(ModalRoot)



// WEBPACK FOOTER //
// ./src/components/layout/ModalRoot.js